import React from 'react';
import {Edit, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import MerchantGroupFields from './MerchantGroupFields'

export const MerchantGroupEdit = props => {
    return (<Edit {...props}>
            <SimpleForm toolbar={<CustomToolbar/>} redirect="list">
                <Grid container spacing={8}>
                    <MerchantGroupFields/>
                </Grid>
            </SimpleForm>
        </Edit>
    )
}

export default MerchantGroupEdit